export const DashboaredHeaderBanner = ({
    className = "dashboard-welcome-banner",
    text = "header 1",
    description = "",
    ...props
}) => {
    return (
        <div className={className} {...props}>
            <h2>{text}</h2>
            <p className="dashboard-welcome-banner__description">
                {description}
            </p>
        </div>
    );
};
